module.exports = __webpack_public_path__ + "media/CandidateList.3d5ad3da.mp4";